import { render, staticRenderFns } from "./select-customer-modal.vue?vue&type=template&id=71270949&scoped=true"
import script from "./select-customer-modal.vue?vue&type=script&lang=js"
export * from "./select-customer-modal.vue?vue&type=script&lang=js"
import style0 from "./select-customer-modal.vue?vue&type=style&index=0&id=71270949&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71270949",
  null
  
)

export default component.exports